import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { getCurrentDocument } from '@completion/selectors';
import { ProcedureDocument, DocumentNode } from '@completion/models';
import { DocumentUpdateQueueService } from '../../../core/services/document-update-queue.service';

/**
 * Clone the current ProcedureDocument, apply a mutator to the target node, and enqueue the document update.
 * This centralizes the node-update cloning/queue pattern used across node components.
 */
export function persistNodeUpdateForNode(
  store: Store,
  updateQueue: DocumentUpdateQueueService,
  targetNode: DocumentNode | null | undefined,
  mutator: (n: any) => void,
): void {
  if (!targetNode) {
    return;
  }
  store
    .select(getCurrentDocument)
    .pipe(take(1))
    .subscribe((doc) => {
      if (!doc) {
        return;
      }
      const cloned: ProcedureDocument = JSON.parse(JSON.stringify(doc));

      const apply = (nodes: any[] | undefined): boolean => {
        if (!nodes) return false;
        for (const n of nodes) {
          if (!n) continue;
          if (n && n.id === (targetNode as any).id) {
            mutator(n);
            return true;
          }
          if (n && n.children && n.children.length) {
            if (apply(n.children)) {
              return true;
            }
          }
        }
        return false;
      };

      if (apply(cloned.nodes || [])) {
        updateQueue.queue(cloned);
      }
    });
}
